import { useQuery } from '@apollo/client/react';
import { GET_APP_CFG } from '@scio3/graphql-client';
import { useTeamStore } from '@/stores/team-store';

// Global MDM kill-switch stored on the shared `appCfgs` singleton
// (`appType: 'scio'`). Absent/false = released only to accounts whitelisted via
// `company.feature.mdm`. True = released to everyone on the optisigns variant.
// Flipped in Mongo; no deploy required to toggle.
interface AppCfgMdmResponse {
  getAppCfgs: {
    mdmEnabled?: boolean;
  } | null;
}

export function useMdmKillSwitch() {
  const activeTeamId = useTeamStore((s) => s.activeTeamId);
  const { data } = useQuery<AppCfgMdmResponse>(GET_APP_CFG, {
    variables: { teamId: activeTeamId, appType: 'scio' },
    skip: !activeTeamId,
  });
  return data?.getAppCfgs?.mdmEnabled === true;
}
